<template>
  <div class="login-page">
    <div class="login-container fade-in">
      <div class="login-banner">
        <div class="banner-content">
          <img src="../assets/biomakers-logo.svg" alt="BioPortal Logo" class="login-logo" />
          <br>
          <br>
          <h1 class="portal-title">BioPortal</h1>
          <p>Sistema avanzado para la gestión de archivos biológicos y datos NGS</p>
          <div class="banner-dots">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
          </div>
        </div>
      </div>
      
      <Card class="login-card">
        <template #title>
          <div class="logo-container">
            <div>
              <h2 class="logo-title">BioPortal</h2>
              <p class="logo-subtitle">Inicio de Sesión</p>
            </div>
          </div>
        </template>
        <template #content>
          <form @submit.prevent="handleSubmit" class="login-form">
            <div class="form-group">
              <label for="email">Correo Electrónico</label>
              <span class="p-input-icon-left w-full">
                <i class="pi pi-envelope"></i>
                <InputText 
                  id="email" 
                  v-model="email" 
                  type="email" 
                  :class="{'p-invalid': submitted && !email}"
                  required 
                  autocomplete="username"
                  placeholder="Ingresa tu correo electrónico"
                  class="w-full"
                />
              </span>
              <small v-if="submitted && !email" class="p-error">El correo electrónico es requerido</small>
            </div>
            
            <div class="form-group">
              <label for="password">Contraseña</label>
              <span class="p-input-icon-left w-full">
                <i class="pi pi-lock"></i>
                <Password 
                  id="password" 
                  v-model="password" 
                  :class="{'p-invalid': submitted && !password}"
                  :feedback="false"
                  toggleMask 
                  required
                  autocomplete="current-password"
                  placeholder="Ingresa tu contraseña"
                  class="w-full"
                  inputClass="w-full"
                />
              </span>
              <small v-if="submitted && !password" class="p-error">La contraseña es requerida</small>
            </div>
            
            <div v-if="error" class="error-message">
              <i class="pi pi-exclamation-triangle"></i> {{ error }}
            </div>
            
            <div class="form-actions">
              <Button 
                type="submit" 
                label="Iniciar Sesión" 
                :loading="loading" 
                class="p-button-primary w-full"
                icon="pi pi-sign-in"
              />
            </div>
            

          </form>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'LoginView',
  data() {
    return {
      email: '',
      password: '',
      submitted: false
    }
  },
  computed: {
    ...mapState('auth', ['loading', 'error'])
  },
  methods: {
    ...mapActions('auth', ['login']),
    
    async handleSubmit() {
      this.submitted = true
      
      // Validar el formulario
      if (!this.email || !this.password) {
        return
      }
      
      // Llamar a la acción de login
      await this.login({
        email: this.email,
        password: this.password
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #7b5bf3 0%, #231462 100%);
  padding: 20px;
}

.login-container {
  display: flex;
  max-width: 900px;
  width: 100%;
  box-shadow: 0 10px 30px rgba(22, 16, 48, 0.3);
  border-radius: 10px;
  overflow: hidden;
  background-color: white;
}

.login-banner {
  flex: 1;
  background: linear-gradient(135deg, #34246A 0%, #7b5bf3 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.banner-content {
  position: relative;
  z-index: 2;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.login-logo {
  width: 180px;
  height: auto;
  margin-bottom: 10px;
  object-fit: contain;
  padding: 20px;
  background-color: #0d0264;
  border-radius: 12px;
}

.portal-title {
  font-size: 2.5rem;
  margin: 0 0 10px 0;
  color: white;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.login-banner p {
  font-size: 1.1rem;
  opacity: 0.9;
  margin-bottom: 20px;
  line-height: 1.4;
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
  color: white;
}

.banner-dots {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.dot {
  width: 10px;
  height: 10px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  display: inline-block;
}

.dot:nth-child(1) {
  animation: pulse 2s infinite;
}

.dot:nth-child(2) {
  animation: pulse 2s infinite 0.5s;
}

.dot:nth-child(3) {
  animation: pulse 2s infinite 1s;
}

.dot:nth-child(4) {
  animation: pulse 2s infinite 1.5s;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    background-color: rgba(255, 255, 255, 0.5);
  }
  50% {
    transform: scale(1.2);
    background-color: rgba(255, 255, 255, 0.9);
  }
  100% {
    transform: scale(1);
    background-color: rgba(255, 255, 255, 0.5);
  }
}

.login-card {
  flex: 1;
  box-shadow: none;
  border-radius: 0;
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 20px 0;
}

.logo-title {
  margin: 0;
  color: var(--primary-color);
  font-size: 1.8rem;
  font-weight: 600;
}

.logo-subtitle {
  margin: 5px 0 0;
  color: var(--text-secondary);
  font-size: 1rem;
}

.login-form {
  padding: 0 0 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: var(--text-primary);
}

.w-full {
  width: 100%;
}

.form-actions {
  margin-top: 25px;
}

.help-links {
  margin-top: 20px;
  text-align: center;
  font-size: 0.9rem;
}

.help-links a {
  color: var(--primary-color);
  text-decoration: none;
}

.help-links a:hover {
  text-decoration: underline;
}

.help-links span {
  margin: 0 8px;
  color: var(--text-secondary);
}

.error-message {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.9rem;
  margin-top: 15px;
}

.error-message i {
  color: var(--error-color);
}

@media (max-width: 768px) {
  .login-container {
    flex-direction: column;
  }
  
  .login-banner {
    padding: 30px 20px;
  }
  
  .login-banner h1 {
    font-size: 2rem;
  }
  
  .login-banner p {
    font-size: 1rem;
  }
  
  .login-card {
    width: 100%;
  }
}
</style> 